/* eslint-disable react/no-danger */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid';
import { Link, useNavigate } from 'react-router-dom';

export const PageTitle = ({
  title, renderTitle, breadcrumbs,
  children, isTopLevel, hideMobile, alignLeft,
}) => {
  const navigate = useNavigate();
  const renderBreadcrumbs = () => {
    return (
      <ol className="flex items-center space-x-4">
        <li>
          <div className="flex">
            <Link to="/" className="text-sm font-medium text-gray-500 hover:text-gray-700">
              Home
            </Link>
          </div>
        </li>
        {breadcrumbs?.map((br, brIndex) => {
          if (brIndex === 0) {
            <li>
              <div className="flex">
                <Link to="/" className="text-sm font-medium text-gray-500 hover:text-gray-700">
                  Home
                </Link>
              </div>
            </li>;
          }

          return (
            // eslint-disable-next-line react/no-array-index-key
            <li key={`breadcrumb_${brIndex}`}>
              <div className="flex items-center">
                <ChevronRightIcon
                  className="flex-shrink-0 h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
                <Link
                  to={br.path || '#'}
                  className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >
                  {br.title}
                </Link>
              </div>
            </li>
          );
        })}
      </ol>
    );
  };

  return (
    <div className={`container ${alignLeft ? '' : 'mx-auto'} px-2 md:px-6 lg:px-8 mb-6 md:mb-10 ${hideMobile ? 'hidden sm:flex' : ''}`}>
      {/* <h3 className="text-lg leading-6 font-medium text-gray-900">Orders</h3> */}
      <div>
        <div>
          {!isTopLevel && (
          <nav className="sm:hidden" aria-label="Back">
            <Link
              to="/"
              onClick={(e) => {
                navigate(-1);
              }}
              className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700"
            >
              <ChevronLeftIcon
                className="flex-shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
              Back
            </Link>
          </nav>
          )}
          <nav className="hidden sm:flex" aria-label="Breadcrumb">
            {renderBreadcrumbs()}
          </nav>
        </div>
        <div className="mt-2 md:flex md:items-center md:justify-between">
          <div className="flex-1 min-w-0">
            <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
              {renderTitle ? renderTitle() : title}
            </h2>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};
